<template lang="pug">
  include ./../../../mixins
  +b.popup-inner.rel
    +e.close-popup.js-close(@click='$emit("close")')
    +b.el
      +b.ds-caption--size_xl.--c_blue.--w_b.custom-title {{trans.title_phone}}
    +b.rel.get-form
      .loading-mask(v-show="isLoading")
        .custom-loader
      validation-observer(
        ref="observer",
        tag="form",
        class="form",
        @submit.prevent="submit"
      )
        +b.el--p_t_lg-md.--p_t_1sm
          +b.g-row--space_xl.rel
            +b.g-cols--12.g-cell
              +b.ds-caption--size_xs.--c_black.--w_r {{trans.name}}
              +b.el--p_t_1xs.rel
                input-group.effect-1(
                  rules='required|text'
                  type="text",
                  name="name"
                  v-model="formData.name"
                  :placeholder="trans.name_place"
                )
                  template(v-slot:error="{errors}")
                    transition(name="fade")
                      span.help--type_error(v-if='errors.length') {{ trans.phone_name }}
            +b.g-cols--12.g-cell.el--m_t_1sm
              +b.ds-caption--size_xs.--c_black.--w_r {{trans.phone}}
              +b.el--p_t_1xs.rel
                input-group(
                  rules='required|phones|min:9|max:16'
                  type="tel",
                  name="phone"
                  v-model="formData.phone"
                  :placeholder="trans.phone_place"
                )
                  template(v-slot:error="{errors}")
                    transition(name="fade")
                      span.help--type_error(v-if='errors.length') {{ trans.phone_valid }}
            +b.g-cols--12
              vue-recaptcha(
                ref="recaptcha"
                size="invisible"
                :sitekey="sitekey"
                @verify="submit"
                @expired="onCaptchaExpired"
              )
            +b.g-cols--12.g-cell.el--m_t_1sm
              +b.btn.--max.--blue.--br.br-none(@click="validate")
                +b.g-row.g-cell
                  +b.P.ds-caption--size_md.--c_white.--w_b {{trans.submit_phone}}
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { submit, openModal, resetForm } from '../Forms/utils';
import FormRequest from '../services/forms';

export default {
  components: { VueRecaptcha },
  data() {
    return {
      formData: {
        title: this.titleForm,
        name: '',
        phone: '',
        captcha: '',
      },
      isLoading: false,
      sitekey: window.captcha,
      error: window.error,
    }
  },
  props: {
    titleForm: String,
  },
  methods: {
    validate() {
      this.$refs.recaptcha.execute()
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    async submit(recaptchaToken) {
      const isValid = await submit(this.$refs.observer)
      this.formData.captcha = recaptchaToken
      if (isValid) {
        this.isLoading = true
        FormRequest.getPhone(this.formData)
          .then(({ data }) => {
            this.isLoading = false
            openModal(this, data.data)
            this.onCaptchaExpired()
            this.formData = resetForm(this.formData)
            requestAnimationFrame(() => {
              this.$refs.observer.reset()
            })
            this.$nextTick(() => {
              this.$emit('close')
            })
          })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            this.isLoading = true
            openModal(this, this.error.data)
            this.isLoading = false
          })
        // eslint-disable-next-line no-empty
      } else {

      }
    },
  },
}

</script>



// WEBPACK FOOTER //
// src/js/components/app/Modals/PhoneModal.vue